<ng-container>
	<div [id]="'filter-product-'+ index" class="fb-filter-product-preview flex flex-col justify-center items-center relative">
		<div *ngIf="badge"
			 [ngClass]="badge === 'In Stock'? 'f-inStock': 'f-mto'"
			 class="rounded px-2 py-1 text-xs absolute top-0 left-0">{{badge}}</div>

		<a [routerLink]="['/product', product.product_group + '-product', product.slug]"  class="w-full">
			<div class=" px-3 pt-3 pb-3">
				<img class="w-full rounded md:rounded-xl max-h-[360px] object-cover object-top"
					 (mouseenter)="isHovered = true"
					 (mouseleave)="isHovered = false"
					 loading="lazy"
					 [@enterAnimation]
					 [src]="isHovered ? ( product.hover_image? product.hover_image:product.hero_image ) : product.hero_image"
					 [alt]="product.name" />
			</div>

<!--			<div class="text-[#75787F] text-xs md:text-sm mt-3 mb-1.5 px-3">{{product.id}}</div>-->
<!--			<div class="text-[#75787F] text-xs md:text-sm mt-3 mb-1.5 px-3">{{product.is_main_product}}</div>-->
			<div class="text-[#75787F] text-xs md:text-sm mt-3 mb-1.5 px-3">{{product.special_status}}</div>
			<div class="text-black text-sm md:text-base mb-1.5 px-3 font-medium hidden sm:block">{{product.name | truncketHtml: 25}}</div>
			<div class="text-black text-sm md:text-base mb-1.5 px-3 font-medium block sm:hidden">{{product.name | truncketHtml: 20}}</div>

			<div class="flex justify-start items-center mb-3 mt-2 text-lg md:text-xl font-medium px-3 text-[#2E2E2E]">
				<span class="text-xs mr-1 text-[#75787F]">{{selectedCurrency | uppercase}}</span> {{product.calculatedPrice | currencyConverter | number: '1.0-2'}}  <span class="text-xs text-[#75787F]">/ {{product.unit}}</span>
			</div>
		</a>

		<div class="px-3 pb-3 w-full flex items-stretch gap-2">
			<button class="w-full bg-[#fffcf7] rounded md:rounded-lg border-2 border-[#8E7862] text-[#7D5B20] py-1 px-3 hover:border-[#6c5b48]
						transition-colors flex items-center justify-center gap-2 text-xs sm:text-sm"
					type="submit">
				<div class="hidden md:block">
					<span class="mt-1 material-symbols-outlined">
						{{ isLoggedIn ? 'shoppingmode' : 'account_circle' }}
					</span>
				</div>
				<a routerLink="/auth" (click)="storeUrl()" *ngIf="!isLoggedIn"
				   class="text-[10px] sm:text-sm w-full"> Login to get bulk price</a>
				<a [routerLink]="['/product', product.product_group + '-product', product.slug]"

				   *ngIf="isLoggedIn" class="w-full">
					<span class="text-[10px] sm:text-sm">Bulk Order @ {{selectedCurrency | uppercase}}</span> {{ bulkPrice | currencyConverter | number: '1.0-2'}}
				</a>
			</button>
			<div (click)="toggleWishlist()"
				 class="w-max bg-[#fffcf7] rounded md:rounded-lg border-2 border-[#8E7862]
			 text-[#7D5B20] py-1.5 px-1 cursor-pointer flex justify-center items-center">
				<img *ngIf="!product.inWishlist" class="" src="assets/img/non-favourite.svg" alt="">
				<img *ngIf="product.inWishlist" class="" src="assets/img/favourite.svg" alt="">
			</div>
		</div>

	</div>
	<div *ngIf="relatedProducts && relatedProducts.length > 0"
		 class="m-2 flex justify-center items-center flex-wrap gap-2">
		<ng-container *ngFor="let related of relatedProducts; let i = index">
			<a *ngIf="i <= 4"
			   [routerLink]="['/product', related.product_group + '-product', related.slug]"

			   class="fb-filter-product-rec rounded-[50%] overflow-hidden">
				<img [src]="related.hero_image" [alt]="related.name"
					 class="w-full h-full object-cover">
			</a>
		</ng-container>
		<a *ngIf="relatedProducts.length > 5"
		   [routerLink]="['/product', productGroup, product.slug]"

		   class="fb-filter-product-rec-plus p-1 text-xs w-8 h-8 rounded-[50%] text-center flex justify-center items-center">
			+{{relatedProducts.length - 5}}
		</a>
	</div>
</ng-container>
